module.exports = __webpack_public_path__ + "img/4.3d3a9949.png";